module.exports = __webpack_public_path__ + "img/Cannon20_Express.0da4812b.png";